export default __webpack_public_path__ + "static/backstagesupport-49-028fbfa7c00e609c6aabf65043a1954a.png";